import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { fill: true },
  },
});

type AlertSuccessIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function AlertSuccessIcon({
  className,
  pathClassName = "fill-green-500",
  ...props
}: AlertSuccessIconProps) {
  return (
    <Svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829L4.76 9.757 9.003 14z"
        fill="#38A169"
        className={pathClassName}
      />
    </Svg>
  );
}

export default AlertSuccessIcon;
